import React from 'react'
import Button from '@material-ui/core/Button'
import {useTranslation} from "react-i18next";

const CustomUserNotificationsActions = (props) => {
    const {t} = useTranslation();

    const handleTestSend = () => {
        props.onHandleTestSend();
    }

    return (
      <div className="custom-user-notifications__actions">
          <Button className="custom-user-notifications__actions--enable"
                  variant="outlined"
                  onClick={() => handleTestSend()}>
              {t('custom_user_notifications.send_test_btn')}
          </Button>

          <Button className="custom-user-notifications__actions--disable"
                  type="submit"
                  variant="contained"
                  color="primary">
              {t('custom_user_notifications.submit_btn')}
          </Button>
      </div>
    )
}

export default CustomUserNotificationsActions